/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolLanIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-lan"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M2.67 19.68L2.67 17.32Q2.67 16.2 3.44 15.44Q4.2 14.68 5.33 14.68L5.67 14.68L5.67 13.32Q5.67 12.2 6.44 11.44Q7.2 10.68 8.32 10.68L10.68 10.68L10.68 9.32L10.32 9.32Q9.2 9.32 8.44 8.56Q7.67 7.8 7.67 6.67L7.67 4.33Q7.67 3.2 8.44 2.44Q9.2 1.68 10.32 1.68L13.68 1.68Q14.8 1.68 15.56 2.44Q16.32 3.2 16.32 4.33L16.32 6.67Q16.32 7.8 15.56 8.56Q14.8 9.32 13.68 9.32L13.32 9.32L13.32 10.68L15.68 10.68Q16.8 10.68 17.56 11.44Q18.32 12.2 18.32 13.32L18.32 14.68L18.68 14.68Q19.8 14.68 20.56 15.44Q21.32 16.2 21.32 17.32L21.32 19.68Q21.32 20.8 20.56 21.56Q19.8 22.32 18.68 22.32L15.32 22.32Q14.2 22.32 13.44 21.56Q12.68 20.8 12.68 19.68L12.68 17.32Q12.68 16.2 13.44 15.44Q14.2 14.68 15.32 14.68L15.68 14.68L15.68 13.32Q15.68 13.32 15.68 13.32Q15.68 13.32 15.68 13.32L8.32 13.32Q8.32 13.32 8.32 13.32Q8.32 13.32 8.32 13.32L8.32 14.68L8.68 14.68Q9.8 14.68 10.56 15.44Q11.32 16.2 11.32 17.32L11.32 19.68Q11.32 20.8 10.56 21.56Q9.8 22.32 8.68 22.32L5.33 22.32Q4.2 22.32 3.44 21.56Q2.67 20.8 2.67 19.68Z" fill={color} />
    </svg>
  );
}
